import { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";

import CompanyComponent, {
  AddFranchise,
} from "../../../components/CompanyComponent";
import { createContext, useContext } from "react";
import { getFranchiseList } from "../../../apis/Business/FranchiseApi";
import "./tablefranchise.css";
import { useTranslation } from "react-i18next";
import { YearTabContext } from "../../../components/Skeleton";
import { useUserAccess } from "../../../components/WriteAccessContext";

export const Header = () => {
  const { t } = useTranslation();
  return (
    <div className="companydetail__group table__header table__franchise">
      <div className="companydetail__row" style={{ backgroundImage: "none" }}>
        <div
          className="modaladdlocation__question"
          style={{ backgroundImage: "none", backgroundColor: "transparent" }}
        >
          <h6>{t("FRANCHISE_NAME")}</h6>
        </div>
        <div className="modaladdlocation__question">
          <h6>{t("FLOOR_SPACE")}</h6>
        </div>
      </div>
    </div>
  );
};

export const ApiVarFranchiseContext = createContext();
const Franchises = ({ setEditSections }) => {
  const yearTab = useContext(YearTabContext);
  const urlParams = new URLSearchParams(window.location.search);
  const year = urlParams.get("year");
  const apiVariable = ["name", "floor_space"];

  let { businessId } = useParams();

  const [vehicles, setVehicles] = useState([]);

  const [editVehicles, setEditVehicles] = useState([]);

  const { userAccess } = useUserAccess();
  const [tipScroll, setTipScroll] = useState("normal");

  useEffect(() => {
    if (tipScroll === "scrolled") {
      setTimeout(() => setTipScroll("done"), 3000);
    }
  }, [tipScroll]);

  useEffect(() => {
    if (yearTab || year)
      getFranchiseList({ businessId: businessId, setObjects: setVehicles });
  }, [yearTab, year, businessId]);

  return (
    <ApiVarFranchiseContext.Provider value={apiVariable}>
      {vehicles.map((vehicle, i) => {
        return (
          <Link
            className="nav-link"
            to={`/company/franchise/${vehicle.id}?year=` + year}
          >
            <CompanyComponent index={i} name={vehicle.name} />
          </Link>
        );
      })}

      {userAccess === "write" && (
        <Link className="nav-link" to={"/company/add-franchise?year=" + year}>
          <AddFranchise />
        </Link>
      )}
    </ApiVarFranchiseContext.Provider>
  );
};

export default Franchises;
